import type { QueryClient } from '@tanstack/react-query';
import { invoiceKeys, jobKeys, paymentKeys, paymentScheduleKeys } from '@/lib/queryKeys';

export function invalidatePaymentScheduleEffects(queryClient: QueryClient, jobId: string) {
  void queryClient.invalidateQueries({ queryKey: paymentScheduleKeys.byJob(jobId) });
  void queryClient.invalidateQueries({ queryKey: invoiceKeys.byJobPrefix(jobId) });
  void queryClient.invalidateQueries({ queryKey: paymentKeys.lists() });
  void queryClient.invalidateQueries({ queryKey: jobKeys.payments(jobId) });
  void queryClient.invalidateQueries({ queryKey: jobKeys.financialSummary(jobId) });
  void queryClient.invalidateQueries({ queryKey: jobKeys.detail(jobId) });
}
